<div 
    *ngIf="caseId && form_name" class="z-30 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); handleClose();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="w-full max-w-screen-sm flex my-6 p-8 gap-8 bg-white rounded-md shadow-lg overflow-hidden" (click)="$event.stopPropagation()">
            <form
                (ngSubmit)="$event.preventDefault(); handleSendRequest();"
                [formGroup]="rejectionForm" 
                class="w-full flex flex-col overflow-hidden"
            >
                <h2 class="w-full oswald-font text-xl font-medium text-start text-nside-orange-400">
                    Reject {{ form_name }} for case {{ caseId }}?
                </h2>
                <p class="w-full text-start pb-4">
                    Please explain why you are rejecting this case.
                </p>
                <div class="w-full flex flex-col items-center px-1 mb-2">
                    <textarea 
                        formControlName="note"
                        rows="5"
                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                        placeholder="Explanation..."
                    ></textarea>
                </div>
                <div class="w-full my-2 flex items-end justify-between oswald-font">
                    <div class="h-full w-full flex items-end justify-end gap-2">
                        <button
                            class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                            (click)="$event.preventDefault(); handleClose();"
                        >
                            Close
                        </button>
                        <button 
                            type="submit"
                            class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                            [ngClass]="{
                                'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.rejectionForm.invalid,
                                'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.rejectionForm.valid
                            }"
                            [disabled]="this.rejectionForm.invalid"
                        >
                            Reject
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>
